import { useAuth } from 'react-oidc-context';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { useEffect } from 'react';

const LoginPage = () => {
    const auth = useAuth();

    const handleLogin = async () => {
        try {
            await auth.signinRedirect();
            
        } catch (error) {
            console.error('Login error:', error);
        } finally {
        }
    };

    if (auth.isLoading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            minHeight="100vh"
            gap={3}
        >
            <Typography variant="h4" component="h1">
                工事管理システム
            </Typography>
            <Button
                variant="contained"
                size="large"
                onClick={handleLogin}
                disabled={auth.isLoading}
            >
                ログイン
            </Button>
        </Box>
    );
};

export default LoginPage;